import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { scrollToId, IMG } from "@/lib/site";

export default function Story() {
  return (
    <section id="story" data-testid="story-section" className="bg-cream py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-5 md:px-10">
        <div className="grid gap-16 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <div className="lg:sticky lg:top-28">
              <Reveal>
                <p className="font-heading text-[7rem] leading-none text-gold/40 md:text-[10rem]">
                  01
                </p>
                <p className="mt-2 text-xs font-semibold uppercase tracking-[0.35em] text-gold">
                  Our Story
                </p>
                <h2 className="mt-5 font-heading text-4xl leading-[1.08] text-forest sm:text-5xl">
                  From India&apos;s Traditions <span className="italic">to Your Home</span>
                </h2>
              </Reveal>
              <Reveal delay={0.15}>
                <div className="group mt-10 overflow-hidden rounded-[28px] shadow-[0_40px_80px_-35px_rgba(26,54,38,0.45)]">
                  <img
                    data-testid="story-image"
                    src={IMG.farm}
                    alt="Golden sunset over rural Indian farmland"
                    className="aspect-[4/3] w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                  />
                </div>
              </Reveal>
            </div>
          </div>

          <div className="flex flex-col justify-center lg:col-span-7 lg:pl-10">
            <Reveal>
              <p className="font-heading text-2xl italic leading-snug text-forest md:text-3xl">
                In Indian homes, ghee has never been just an ingredient. It is
                a memory — of slow mornings, of festivals, of food made with
                patience.
              </p>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="mt-8 text-base leading-relaxed text-charcoal/70 md:text-lg">
                MAHIRA was born from a simple belief: that the honesty of
                India&apos;s dairy tradition deserves a place on the modern
                table. We began with one product done properly — A2 Gir Cow
                Ghee — sourced with care, prepared with respect for tradition,
                and packed to a standard we would serve in our own home.
              </p>
            </Reveal>
            <Reveal delay={0.18}>
              <p className="mt-6 text-base leading-relaxed text-charcoal/70 md:text-lg">
                Our vision reaches further. From Navi Mumbai to the GCC and
                beyond, MAHIRA is building a house of authentic Indian
                agro-products that modern families anywhere in the world can
                trust.
              </p>
            </Reveal>
            <Reveal delay={0.26}>
              <p className="mt-10 text-xs font-semibold uppercase tracking-[0.35em] text-gold">
                Discover the MAHIRA Difference
              </p>
              <button
                data-testid="story-explore-cta"
                onClick={() => scrollToId("difference")}
                className="group mt-5 inline-flex items-center gap-3 rounded-full bg-forest px-8 py-4 text-[12px] font-semibold uppercase tracking-[0.18em] text-ivory transition-[background-color,transform] duration-300 hover:-translate-y-1 hover:bg-forest-light"
              >
                Explore MAHIRA
                <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
              </button>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
